<div class="fpx-form-control">
  <fpx-label *ngIf="label" [control]="formControl" [label]="label" ></fpx-label>
  <div class="control-date-wrapper">
    <input matInput [(ngModel)]="selectedDate"
      [min]="minDate" [max]="maxDate" [readonly]="true"
      (dateChange)="onDatechange()" [matDatepicker]="datePicker"
      [ngClass]="{'input-available': formControl.value}" />
    <mat-datepicker-toggle matSuffix [for]="datePicker" [disabled]="formControl.disabled">
      <mat-icon class="calender-icon" matDatepickerToggleIcon>calendar_month</mat-icon>
    </mat-datepicker-toggle>
    <mat-placeholder *ngIf="placeholder" class="placeholder">{{ placeholder }}</mat-placeholder>
    <mat-datepicker #datePicker></mat-datepicker>
  </div>
  <mat-error *ngIf="formControl && formControl.invalid && formControl.touched">
    {{ errorCode }}
  </mat-error>
</div>